import { type NavigateFunction } from "react-router-dom";
import { replaceQueryString } from "./api";

type Navigation = {
  goTo: NavigateFunction;
  push: any;
};
const navigation: Navigation = {
  goTo: () => {},
  push: (page, ...rest) => navigation.goTo!(page, ...rest)
};

export default navigation;

const SYSTEM_ROUTES = ["api", "logout", "builder", "funnelpath", "viewer", "track"];
export const isSystemRoute = (url: string): boolean => {
  const lu = url.replace(/^\//, "").toLowerCase();
  return SYSTEM_ROUTES.some((x) => lu.startsWith(x));
};

export const goTo = (url: string, replace: boolean = false) => {
  if (isSystemRoute(url) || url.startsWith("http")) {
    // NOTE: we used to check if the url is on the same domain, and used goTo,
    // but we cannot do that, because in that case portalId will be preserved.
    window.location.assign(url);
  } else {
    navigation.goTo(url, { replace });
  }
};

export const replaceUrlQuery = (qs: object) =>
  window.history.pushState("{}", "", replaceQueryString(window.location.href, qs));
